import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { Label, Title } from "components/generic";
import { ContainerLeftSide, LeftMenu } from "./styles";

import { hostRoutes, studentRoutes } from "routes";
import { useContextHospi } from "../../context/ContextHospi";
import { hostMenuRoutes, studentMenuRoutes } from "components/Menu";
import React from "react";
import { VerificationBanner } from "../VerificationBanner";

export const MenuLeftSide: React.FC<{ routeActive?: string }> = ({
  routeActive,
}) => {
  const { userStatus, unreadConversations } = useContextHospi();
  const { t, i18n } = useTranslation('header');

  return (
    <ContainerLeftSide>
      <LeftMenu>
        <Title m="0 0 18px 16px" fontSize="24px">
          {t("menu.login")}
        </Title>
        <ul>
          {(userStatus === "host" ? hostRoutes : studentRoutes)
            .filter((item) =>
              (userStatus === "host"
                ? hostMenuRoutes
                : studentMenuRoutes
              ).includes(item.path)
            )
            .map((item, iter) => (
              <li key={`/${i18n.language}${item.path.slice(5)}`}>
                <NavLink
                  to={`/${i18n.language}${item.path.slice(5)}`}
                  className={`${routeActive && routeActive === `/${i18n.language}${item.path.slice(5)}` ? " keep" : ""
                    }`}
                >
                  <Label fontSize="20px" cursor="pointer" style={{ position: 'relative' }}>
                    {iter + 1}. {t(`subMenu.${item.keyLocalize}`)}
                    {
                      (item.keyLocalize === 'chats' && unreadConversations.length) ? <div style={{ position: 'absolute', top: 'calc(50% - 1.5px)', right: 0, width: 5, height: 5, borderRadius: '50%', background: '#032565' }} /> : ''
                    }
                  </Label>
                </NavLink>
              </li>
            ))}
        </ul>
      </LeftMenu>
      {userStatus === 'host' && (<VerificationBanner />)}
    </ContainerLeftSide>
  );
};
